import $M$ClusteredFeature from './facade/js/feature/Clustered';
import $M$Control from './facade/js/control/Control';
import $M$Feature from './facade/js/feature/Feature';
import $M$Filter from './facade/js/filter/Base';
import $M$Label from './facade/js/Label';
import $M$Layer from './facade/js/layer/Layer';
import $M$Map from './facade/js/Map';
import $M$Object from './facade/js/Object';
import $M$Parameters from './facade/js/parameter/Parameters';
import $M$Plugin from './facade/js/Plugin';
import $M$Popup from './facade/js/Popup';
import $M$RenderFeature from './facade/js/feature/RenderFeature';
import $M$Style from './facade/js/style/Style';
import $M$control$BackgroundLayers from './facade/js/control/BackgroundLayers';
import $M$control$GetFeatureInfo from './facade/js/control/GetFeatureInfo';
import $M$control$Location from './facade/js/control/Location';
import $M$control$Panzoom from './facade/js/control/Panzoom';
import $M$control$Panzoombar from './facade/js/control/Panzoombar';
import $M$control$Rotate from './facade/js/control/Rotate';
import $M$control$Scale from './facade/js/control/Scale';
import $M$control$ScaleLine from './facade/js/control/ScaleLine';
import $M$control$WMCSelector from './facade/js/control/WMCSelector';
import $M$evt$EventsManager from './facade/js/event/Manager';
import $M$evt$Listener from './facade/js/event/Listener';
import $M$exception from './facade/js/exception/exception';
import $M$facade$Base from './facade/js/Base';
import $M$filter from './facade/js/filter/Spatial';
import $M$filter$Function from './facade/js/filter/Function';
import $M$format$GeoJSON from './facade/js/format/GeoJSON';
import $M$format$WKT from './facade/js/format/WKT';
import $M$handler$Feature from './facade/js/handler/Feature';
import $M$impl$Control from './impl/ol/js/control/Control';
import $M$impl$Feature from './impl/ol/js/feature/Feature';
import $M$impl$GetCapabilities from './impl/ol/js/util/WMSCapabilities';
import $M$impl$Label from './impl/ol/js/Label';
import $M$impl$Layer from './impl/ol/js/layer/Layer';
import $M$impl$Map from './impl/ol/js/Map';
import $M$impl$Popup from './impl/ol/js/Popup';
import $M$impl$RenderFeature from './impl/ol/js/feature/RenderFeature';
import $M$impl$Style from './impl/ol/js/style/Style';
import $M$impl$View from './impl/ol/js/View';
import $M$impl$control$GetFeatureInfo from './impl/ol/js/control/GetFeatureInfo';
import $M$impl$control$Location from './impl/ol/js/control/Location';
import $M$impl$control$Panzoom from './impl/ol/js/control/Panzoom';
import $M$impl$control$Panzoombar from './impl/ol/js/control/Panzoombar';
import $M$impl$control$Rotate from './impl/ol/js/control/Rotate';
import $M$impl$control$Scale from './impl/ol/js/control/Scale';
import $M$impl$control$ScaleLine from './impl/ol/js/control/ScaleLine';
import $M$impl$control$WMCSelector from './impl/ol/js/control/WMCSelector';
import $M$impl$format$DescribeFeatureType from './impl/ol/js/format/wfs/DescribeFeatureType';
import $M$impl$format$DescribeFeatureTypeXML from './impl/ol/js/format/wfs/DescribeFeatureTypeXML';
import $M$impl$format$GML from './impl/ol/js/format/GML';
import $M$impl$format$GeoJSON from './impl/ol/js/format/GeoJSON';
import $M$impl$format$KML from './impl/ol/js/format/KML';
import $M$impl$format$WKT from './impl/ol/js/format/WKT';
import $M$impl$format$WMC from './impl/ol/js/format/wmc/WMC';
import $M$impl$format$WMSCapabilities from './impl/ol/js/format/WMS';
import $M$impl$format$WMTSCapabilities from './impl/ol/js/format/WMTS';
import $M$impl$format$XML from './impl/ol/js/format/XML';
import $M$impl$handler$Feature from './impl/ol/js/handler/Feature';
import $M$impl$interaction$SelectCluster from './impl/ol/js/interaction/SelectedCluster';
import $M$impl$layer$AnimatedCluster from './impl/ol/js/layer/AnimatedCluster';
import $M$impl$layer$Draw from './impl/ol/js/layer/Draw';
import $M$impl$layer$GeoJSON from './impl/ol/js/layer/GeoJSON';
import $M$impl$layer$KML from './impl/ol/js/layer/KML';
import $M$impl$layer$LayerGroup from './impl/ol/js/layer/LayerGroup';
import $M$impl$layer$MBTiles from './impl/ol/js/layer/MBTiles';
import $M$impl$layer$MBTilesVector from './impl/ol/js/layer/MBTilesVector';
import $M$impl$layer$MVT from './impl/ol/js/layer/MVT';
import $M$impl$layer$OSM from './impl/ol/js/layer/OSM';
import $M$impl$layer$TMS from './impl/ol/js/layer/TMS';
import $M$impl$layer$Vector from './impl/ol/js/layer/Vector';
import $M$impl$layer$WFS from './impl/ol/js/layer/WFS';
import $M$impl$layer$WMC from './impl/ol/js/layer/WMC';
import $M$impl$layer$WMS from './impl/ol/js/layer/WMS';
import $M$impl$layer$WMTS from './impl/ol/js/layer/WMTS';
import $M$impl$layer$XYZ from './impl/ol/js/layer/XYZ';
import $M$impl$loader$JSONP from './impl/ol/js/loader/JSONP';
import $M$impl$loader$KML from './impl/ol/js/loader/KML';
import $M$impl$loader$WFS from './impl/ol/js/loader/WFS';
import $M$impl$service$WFS from './impl/ol/js/service/WFS';
import $M$impl$source$ImageWMS from './impl/ol/js/source/ImageWMS';
import $M$impl$source$TileWMS from './impl/ol/js/source/TileWMS';
import $M$impl$style$Centroid from './impl/ol/js/style/Centroid';
import $M$impl$style$Cluster from './impl/ol/js/style/Cluster';
import $M$impl$style$Icon from './impl/ol/js/style/Icon';
import $M$impl$style$Line from './impl/ol/js/style/Line';
import $M$impl$style$Path from './impl/ol/js/style/Path';
import $M$impl$style$Point from './impl/ol/js/style/Point';
import $M$impl$style$Polygon from './impl/ol/js/style/Polygon';
import $M$impl$style$Simple from './impl/ol/js/style/Simple';
import $M$impl$util$wmtscapabilities from './impl/ol/js/util/wmtscapabilities';
import $M$impl$utils from './impl/ol/js/util/Utils';
import $M$layer$GeoJSON from './facade/js/layer/GeoJSON';
import $M$layer$KML from './facade/js/layer/KML';
import $M$layer$LayerGroup from './facade/js/layer/LayerGroup';
import $M$layer$MBTiles from './facade/js/layer/MBTiles';
import $M$layer$MBTilesVector from './facade/js/layer/MBTilesVector';
import $M$layer$MVT from './facade/js/layer/MVT';
import $M$layer$OSM from './facade/js/layer/OSM';
import $M$layer$TMS from './facade/js/layer/TMS';
import $M$layer$Vector from './facade/js/layer/Vector';
import $M$layer$WFS from './facade/js/layer/WFS';
import $M$layer$WMC from './facade/js/layer/WMC';
import $M$layer$WMS from './facade/js/layer/WMS';
import $M$layer$WMTS from './facade/js/layer/WMTS';
import $M$layer$XYZ from './facade/js/layer/XYZ';
import $M$parameter$mbtiles from './facade/js/parameter/mbtiles';
import $M$parameter$mbtilesvector from './facade/js/parameter/mbtilesvector';
import $M$parameter$osm from './facade/js/parameter/osm';
import $M$parameter$tms from './facade/js/parameter/tms';
import $M$parameter$wmc from './facade/js/parameter/wmc';
import $M$parameter$wms from './facade/js/parameter/wms';
import $M$parameter$xyz from './facade/js/parameter/xyz';
import $M$remote$Response from './facade/js/util/Response';
import $M$style$Cluster from './facade/js/style/Cluster';
import $M$style$Composite from './facade/js/style/Composite';
import $M$style$Feature from './facade/js/style/Feature';
import $M$style$Line from './facade/js/style/Line';
import $M$style$Point from './facade/js/style/Point';
import $M$style$Polygon from './facade/js/style/Polygon';
import $M$style$Simple from './facade/js/style/Simple';
import $M$ui$Panel from './facade/js/ui/Panel';
import $M$window from './facade/js/util/Window';
import * as MModule from './facade/js/mapea';
import * as MdialogModule from './facade/js/dialog';
import * as MevtModule from './facade/js/event/eventtype';
import * as MfilterModule from './facade/js/filter/Filter';
import * as MfilterspatialModule from './facade/js/filter/Module';
import * as MgeomModule from './facade/js/geom/Geom';
import * as MgeomgeojsontypeModule from './facade/js/geom/GeoJSON';
import * as MgeomwfstypeModule from './facade/js/geom/WFS';
import * as MgeomwkttypeModule from './facade/js/geom/WKT';
import * as MimplutilwmtscapabilitiesModule from './impl/ol/js/util/wmtscapabilities';
import * as MlanguageModule from './facade/js/i18n/language';
import * as MlayerMBTilesVectorModule from './facade/js/layer/MBTilesVector';
import * as MlayerMVTModule from './facade/js/layer/MVT';
import * as MlayertypeModule from './facade/js/layer/Type';
import * as MparameterModule from './facade/js/parameter/parameter';
import * as MremoteModule from './facade/js/util/Remote';
import * as MstylealignModule from './facade/js/style/Align';
import * as MstylebaselineModule from './facade/js/style/Baseline';
import * as MstyleformModule from './facade/js/style/Form';
import * as MstylepatternModule from './facade/js/style/Pattern';
import * as MstylestateModule from './facade/js/style/State';
import * as MstyletextoverflowModule from './facade/js/style/Textoverflow';
import * as MtemplateModule from './facade/js/util/Template';
import * as MuipositionModule from './facade/js/ui/position';
import * as MunitsModule from './facade/js/units';
import * as MutilsModule from './facade/js/util/Utils';

/* eslint-disable */

import $ol$AssertionError from 'ol/AssertionError';
import $ol$Collection from 'ol/Collection';
import $ol$Feature from 'ol/Feature';
import $ol$Geolocation from 'ol/Geolocation';
import $ol$Image from 'ol/Image';
import $ol$ImageTile from 'ol/ImageTile';
import $ol$Kinetic from 'ol/Kinetic';
import $ol$Map from 'ol/Map';
import $ol$MapBrowserEvent from 'ol/MapBrowserEvent';
import $ol$MapEvent from 'ol/MapEvent';
import $ol$Object from 'ol/Object';
import $ol$Observable from 'ol/Observable';
import $ol$Overlay from 'ol/Overlay';
import $ol$PluggableMap from 'ol/PluggableMap';
import $ol$Tile from 'ol/Tile';
import $ol$VectorTile from 'ol/VectorTile';
import $ol$View from 'ol/View';
import $ol$control$Attribution from 'ol/control/Attribution';
import $ol$control$Control from 'ol/control/Control';
import $ol$control$FullScreen from 'ol/control/FullScreen';
import $ol$control$MousePosition from 'ol/control/MousePosition';
import $ol$control$OverviewMap from 'ol/control/OverviewMap';
import $ol$control$Rotate from 'ol/control/Rotate';
import $ol$control$ScaleLine from 'ol/control/ScaleLine';
import $ol$control$Zoom from 'ol/control/Zoom';
import $ol$control$ZoomSlider from 'ol/control/ZoomSlider';
import $ol$control$ZoomToExtent from 'ol/control/ZoomToExtent';
import $ol$events$Event from 'ol/events/Event';
import $ol$events$Target from 'ol/events/Target';
import $ol$format$EsriJSON from 'ol/format/EsriJSON';
import $ol$format$Feature from 'ol/format/Feature';
import $ol$format$GML from 'ol/format/GML';
import $ol$format$GML2 from 'ol/format/GML2';
import $ol$format$GML3 from 'ol/format/GML3';
import $ol$format$GML32 from 'ol/format/GML32';
import $ol$format$GPX from 'ol/format/GPX';
import $ol$format$GeoJSON from 'ol/format/GeoJSON';
import $ol$format$IGC from 'ol/format/IGC';
import $ol$format$IIIFInfo from 'ol/format/IIIFInfo';
import $ol$format$JSONFeature from 'ol/format/JSONFeature';
import $ol$format$KML from 'ol/format/KML';
import $ol$format$MVT from 'ol/format/MVT';
import $ol$format$OSMXML from 'ol/format/OSMXML';
import $ol$format$Polyline from 'ol/format/Polyline';
import $ol$format$TextFeature from 'ol/format/TextFeature';
import $ol$format$TopoJSON from 'ol/format/TopoJSON';
import $ol$format$WFS from 'ol/format/WFS';
import $ol$format$WKT from 'ol/format/WKT';
import $ol$format$WMSCapabilities from 'ol/format/WMSCapabilities';
import $ol$format$WMSGetFeatureInfo from 'ol/format/WMSGetFeatureInfo';
import $ol$format$WMTSCapabilities from 'ol/format/WMTSCapabilities';
import $ol$format$XML from 'ol/format/XML';
import $ol$format$XMLFeature from 'ol/format/XMLFeature';
import $ol$format$filter$Bbox from 'ol/format/filter/Bbox';
import $ol$format$filter$Contains from 'ol/format/filter/Contains';
import $ol$format$filter$During from 'ol/format/filter/During';
import $ol$format$filter$EqualTo from 'ol/format/filter/EqualTo';
import $ol$format$filter$GreaterThan from 'ol/format/filter/GreaterThan';
import $ol$format$filter$GreaterThanOrEqualTo from 'ol/format/filter/GreaterThanOrEqualTo';
import $ol$format$filter$Intersects from 'ol/format/filter/Intersects';
import $ol$format$filter$IsBetween from 'ol/format/filter/IsBetween';
import $ol$format$filter$IsLike from 'ol/format/filter/IsLike';
import $ol$format$filter$IsNull from 'ol/format/filter/IsNull';
import $ol$format$filter$LessThan from 'ol/format/filter/LessThan';
import $ol$format$filter$LessThanOrEqualTo from 'ol/format/filter/LessThanOrEqualTo';
import $ol$format$filter$Not from 'ol/format/filter/Not';
import $ol$format$filter$NotEqualTo from 'ol/format/filter/NotEqualTo';
import $ol$format$filter$Or from 'ol/format/filter/Or';
import $ol$format$filter$Within from 'ol/format/filter/Within';
import $ol$geom$Circle from 'ol/geom/Circle';
import $ol$geom$Geometry from 'ol/geom/Geometry';
import $ol$geom$GeometryCollection from 'ol/geom/GeometryCollection';
import $ol$geom$LineString from 'ol/geom/LineString';
import $ol$geom$LinearRing from 'ol/geom/LinearRing';
import $ol$geom$MultiLineString from 'ol/geom/MultiLineString';
import $ol$geom$MultiPoint from 'ol/geom/MultiPoint';
import $ol$geom$MultiPolygon from 'ol/geom/MultiPolygon';
import $ol$geom$Point from 'ol/geom/Point';
import $ol$geom$Polygon from 'ol/geom/Polygon';
import $ol$geom$SimpleGeometry from 'ol/geom/SimpleGeometry';
import $ol$interaction$DoubleClickZoom from 'ol/interaction/DoubleClickZoom';
import $ol$interaction$DragAndDrop from 'ol/interaction/DragAndDrop';
import $ol$interaction$DragBox from 'ol/interaction/DragBox';
import $ol$interaction$DragPan from 'ol/interaction/DragPan';
import $ol$interaction$DragRotate from 'ol/interaction/DragRotate';
import $ol$interaction$DragRotateAndZoom from 'ol/interaction/DragRotateAndZoom';
import $ol$interaction$DragZoom from 'ol/interaction/DragZoom';
import $ol$interaction$Draw from 'ol/interaction/Draw';
import $ol$interaction$Extent from 'ol/interaction/Extent';
import $ol$interaction$Interaction from 'ol/interaction/Interaction';
import $ol$interaction$KeyboardPan from 'ol/interaction/KeyboardPan';
import $ol$interaction$KeyboardZoom from 'ol/interaction/KeyboardZoom';
import $ol$interaction$Modify from 'ol/interaction/Modify';
import $ol$interaction$MouseWheelZoom from 'ol/interaction/MouseWheelZoom';
import $ol$interaction$PinchRotate from 'ol/interaction/PinchRotate';
import $ol$interaction$PinchZoom from 'ol/interaction/PinchZoom';
import $ol$interaction$Pointer from 'ol/interaction/Pointer';
import $ol$interaction$Select from 'ol/interaction/Select';
import $ol$interaction$Snap from 'ol/interaction/Snap';
import $ol$interaction$Translate from 'ol/interaction/Translate';
import $ol$layer$Base from 'ol/layer/Base';
import $ol$layer$BaseImage from 'ol/layer/BaseImage';
import $ol$layer$BaseTile from 'ol/layer/BaseTile';
import $ol$layer$BaseVector from 'ol/layer/BaseVector';
import $ol$layer$Graticule from 'ol/layer/Graticule';
import $ol$layer$Group from 'ol/layer/Group';
import $ol$layer$Heatmap from 'ol/layer/Heatmap';
import $ol$layer$Image from 'ol/layer/Image';
import $ol$layer$Layer from 'ol/layer/Layer';
import $ol$layer$Tile from 'ol/layer/Tile';
import $ol$layer$Vector from 'ol/layer/Vector';
import $ol$layer$VectorImage from 'ol/layer/VectorImage';
import $ol$layer$VectorTile from 'ol/layer/VectorTile';
import $ol$proj$Projection from 'ol/proj/Projection';
import $ol$render$Event from 'ol/render/Event';
import $ol$render$Feature from 'ol/render/Feature';
import $ol$render$VectorContext from 'ol/render/VectorContext';
import $ol$render$canvas$Immediate from 'ol/render/canvas/Immediate';
import $ol$renderer$Composite from 'ol/renderer/Composite';
import $ol$renderer$canvas$ImageLayer from 'ol/renderer/canvas/ImageLayer';
import $ol$renderer$canvas$TileLayer from 'ol/renderer/canvas/TileLayer';
import $ol$renderer$canvas$VectorImageLayer from 'ol/renderer/canvas/VectorImageLayer';
import $ol$renderer$canvas$VectorLayer from 'ol/renderer/canvas/VectorLayer';
import $ol$renderer$canvas$VectorTileLayer from 'ol/renderer/canvas/VectorTileLayer';
import $ol$renderer$webgl$Layer from 'ol/renderer/webgl/Layer';
import $ol$renderer$webgl$PointsLayer from 'ol/renderer/webgl/PointsLayer';
import $ol$source$BingMaps from 'ol/source/BingMaps';
import $ol$source$CartoDB from 'ol/source/CartoDB';
import $ol$source$Cluster from 'ol/source/Cluster';
import $ol$source$IIIF from 'ol/source/IIIF';
import $ol$source$Image from 'ol/source/Image';
import $ol$source$ImageArcGISRest from 'ol/source/ImageArcGISRest';
import $ol$source$ImageCanvas from 'ol/source/ImageCanvas';
import $ol$source$ImageMapGuide from 'ol/source/ImageMapGuide';
import $ol$source$ImageStatic from 'ol/source/ImageStatic';
import $ol$source$ImageWMS from 'ol/source/ImageWMS';
import $ol$source$OSM from 'ol/source/OSM';
import $ol$source$Raster from 'ol/source/Raster';
import $ol$source$Source from 'ol/source/Source';
import $ol$source$Stamen from 'ol/source/Stamen';
import $ol$source$Tile from 'ol/source/Tile';
import $ol$source$TileArcGISRest from 'ol/source/TileArcGISRest';
import $ol$source$TileDebug from 'ol/source/TileDebug';
import $ol$source$TileImage from 'ol/source/TileImage';
import $ol$source$TileJSON from 'ol/source/TileJSON';
import $ol$source$TileWMS from 'ol/source/TileWMS';
import $ol$source$UTFGrid from 'ol/source/UTFGrid';
import $ol$source$UrlTile from 'ol/source/UrlTile';
import $ol$source$Vector from 'ol/source/Vector';
import $ol$source$VectorTile from 'ol/source/VectorTile';
import $ol$source$WMTS from 'ol/source/WMTS';
import $ol$source$XYZ from 'ol/source/XYZ';
import $ol$source$Zoomify from 'ol/source/Zoomify';
import $ol$structs$LRUCache from 'ol/structs/LRUCache';
import $ol$style$Circle from 'ol/style/Circle';
import $ol$style$Fill from 'ol/style/Fill';
import $ol$style$Icon from 'ol/style/Icon';
import $ol$style$IconImageCache from 'ol/style/IconImageCache';
import $ol$style$Image from 'ol/style/Image';
import $ol$style$RegularShape from 'ol/style/RegularShape';
import $ol$style$Stroke from 'ol/style/Stroke';
import $ol$style$Style from 'ol/style/Style';
import $ol$style$Text from 'ol/style/Text';
import $ol$tilegrid$TileGrid from 'ol/tilegrid/TileGrid';
import $ol$tilegrid$WMTS from 'ol/tilegrid/WMTS';
import $ol$webgl$Buffer from 'ol/webgl/Buffer';
import $ol$webgl$Helper from 'ol/webgl/Helper';
import $ol$webgl$PostProcessingPass from 'ol/webgl/PostProcessingPass';
import $ol$webgl$RenderTarget from 'ol/webgl/RenderTarget';
import * as olCollectionModule from 'ol/Collection';
import * as olObjectModule from 'ol/Object';
import * as olObservableModule from 'ol/Observable';
import * as olarrayModule from 'ol/array';
import * as olcolorModule from 'ol/color';
import * as olcolorlikeModule from 'ol/colorlike';
import * as olcontrolModule from 'ol/control';
import * as olcoordinateModule from 'ol/coordinate';
import * as oleasingModule from 'ol/easing';
import * as oleventsconditionModule from 'ol/events/condition';
import * as olextentModule from 'ol/extent';
import * as olfeatureloaderModule from 'ol/featureloader';
import * as olformatPolylineModule from 'ol/format/Polyline';
import * as olformatWFSModule from 'ol/format/WFS';
import * as olformatfilterModule from 'ol/format/filter';
import * as olgeomPolygonModule from 'ol/geom/Polygon';
import * as olhasModule from 'ol/has';
import * as olinteractionDrawModule from 'ol/interaction/Draw';
import * as olinteractionModifyModule from 'ol/interaction/Modify';
import * as olinteractionModule from 'ol/interaction';
import * as olinteractionTranslateModule from 'ol/interaction/Translate';
import * as olloadingstrategyModule from 'ol/loadingstrategy';
import * as olprojModule from 'ol/proj';
import * as olprojUnitsModule from 'ol/proj/Units';
import * as olprojproj4Module from 'ol/proj/proj4';
import * as olrenderModule from 'ol/render';
import * as olrendercanvasModule from 'ol/render/canvas';
import * as olsizeModule from 'ol/size';
import * as olsourceImageModule from 'ol/source/Image';
import * as olsourceOSMModule from 'ol/source/OSM';
import * as olsourceRasterModule from 'ol/source/Raster';
import * as olsourceTileModule from 'ol/source/Tile';
import * as olsourceVectorModule from 'ol/source/Vector';
import * as olsourceWMSServerTypeModule from 'ol/source/WMSServerType';
import * as olsourceWMTSModule from 'ol/source/WMTS';
import * as olsphereModule from 'ol/sphere';
import * as olstyleIconAnchorUnitsModule from 'ol/style/IconAnchorUnits';
import * as olstyleIconImageCacheModule from 'ol/style/IconImageCache';
import * as olstyleIconOriginModule from 'ol/style/IconOrigin';
import * as oltilegridModule from 'ol/tilegrid';
import * as oltilegridWMTSModule from 'ol/tilegrid/WMTS';
import * as oltransformModule from 'ol/transform';
import * as olutilModule from 'ol/util';
import * as olwebglHelperModule from 'ol/webgl/Helper';
import * as olwebglModule from 'ol/webgl';
import * as olxmlModule from 'ol/xml';
const M = window['M'] = {};
const ol = window['ol'] = {}
M.ClusteredFeature = $M$ClusteredFeature;
M.Control = $M$Control;
M.Feature = $M$Feature;
M.Filter = $M$Filter;
M.Label = $M$Label;
M.Layer = $M$Layer;
M.Map = $M$Map;
M.Object = $M$Object;
M.Parameters = $M$Parameters;
M.Plugin = $M$Plugin;
M.Popup = $M$Popup;
M.RenderFeature = $M$RenderFeature;
M.Style = $M$Style;
M.config = MModule.config;
M.control = {};
M.control.BackgroundLayers = $M$control$BackgroundLayers;
M.control.GetFeatureInfo = $M$control$GetFeatureInfo;
M.control.Location = $M$control$Location;
M.control.Panzoom = $M$control$Panzoom;
M.control.Panzoombar = $M$control$Panzoombar;
M.control.Rotate = $M$control$Rotate;
M.control.Scale = $M$control$Scale;
M.control.ScaleLine = $M$control$ScaleLine;
M.control.WMCSelector = $M$control$WMCSelector;
M.dialog = {};
M.dialog.error = MdialogModule.error;
M.dialog.info = MdialogModule.info;
M.dialog.show = MdialogModule.show;
M.dialog.success = MdialogModule.success;
M.evt = {};
M.evt.ACTIVATED = MevtModule.ACTIVATED;
M.evt.ADDED_KML = MevtModule.ADDED_KML;
M.evt.ADDED_LAYER = MevtModule.ADDED_LAYER;
M.evt.ADDED_MBTILES = MevtModule.ADDED_MBTILES;
M.evt.ADDED_MBTILES_VECTOR = MevtModule.ADDED_MBTILES_VECTOR;
M.evt.ADDED_TMS = MevtModule.ADDED_TMS;
M.evt.ADDED_TO_MAP = MevtModule.ADDED_TO_MAP;
M.evt.ADDED_TO_PANEL = MevtModule.ADDED_TO_PANEL;
M.evt.ADDED_VECTOR_TILE = MevtModule.ADDED_VECTOR_TILE;
M.evt.ADDED_WFS = MevtModule.ADDED_WFS;
M.evt.ADDED_WMC = MevtModule.ADDED_WMC;
M.evt.ADDED_WMS = MevtModule.ADDED_WMS;
M.evt.ADDED_WMTS = MevtModule.ADDED_WMTS;
M.evt.ADDED_XYZ = MevtModule.ADDED_XYZ;
M.evt.CHANGE = MevtModule.CHANGE;
M.evt.CHANGE_PROJ = MevtModule.CHANGE_PROJ;
M.evt.CHANGE_ROTATION = MevtModule.CHANGE_ROTATION;
M.evt.CHANGE_STYLE = MevtModule.CHANGE_STYLE;
M.evt.CHANGE_WMC = MevtModule.CHANGE_WMC;
M.evt.CHANGE_ZOOM = MevtModule.CHANGE_ZOOM;
M.evt.CLICK = MevtModule.CLICK;
M.evt.COMPLETED = MevtModule.COMPLETED;
M.evt.DEACTIVATED = MevtModule.DEACTIVATED;
M.evt.DESTROY = MevtModule.DESTROY;
M.evt.DOUBLE_CLICK = MevtModule.DOUBLE_CLICK;
M.evt.EventsManager = $M$evt$EventsManager;
M.evt.HIDE = MevtModule.HIDE;
M.evt.HOVER_FEATURES = MevtModule.HOVER_FEATURES;
M.evt.LEAVE_FEATURES = MevtModule.LEAVE_FEATURES;
M.evt.LOAD = MevtModule.LOAD;
M.evt.Listener = $M$evt$Listener;
M.evt.MOVE = MevtModule.MOVE;
M.evt.REMOVED_FROM_MAP = MevtModule.REMOVED_FROM_MAP;
M.evt.REMOVED_LAYER = MevtModule.REMOVED_LAYER;
M.evt.SELECT_FEATURES = MevtModule.SELECT_FEATURES;
M.evt.SHOW = MevtModule.SHOW;
M.evt.UNSELECT_FEATURES = MevtModule.UNSELECT_FEATURES;
M.exception = $M$exception;
M.facade = {};
M.facade.Base = $M$facade$Base;
M.filter = $M$filter;
M.filter.AND = MfilterModule.AND;
M.filter.EQUAL = MfilterModule.EQUAL;
M.filter.Function = $M$filter$Function;
M.filter.GT = MfilterModule.GT;
M.filter.GTE = MfilterModule.GTE;
M.filter.LIKE = MfilterModule.LIKE;
M.filter.LT = MfilterModule.LT;
M.filter.LTE = MfilterModule.LTE;
M.filter.NOT = MfilterModule.NOT;
M.filter.OR = MfilterModule.OR;
M.filter.spatial = {};
M.filter.spatial.CONTAIN = MfilterspatialModule.CONTAIN;
M.filter.spatial.DISJOINT = MfilterspatialModule.DISJOINT;
M.filter.spatial.INTERSECT = MfilterspatialModule.INTERSECT;
M.filter.spatial.WITHIN = MfilterspatialModule.WITHIN;
M.filter.spatial.parseParamToGeometries = MfilterspatialModule.parseParamToGeometries;
M.format = {};
M.format.GeoJSON = $M$format$GeoJSON;
M.format.WKT = $M$format$WKT;
M.geom = {};
M.geom.geojson = {};
M.geom.geojson.type = {};
M.geom.geojson.type.GEOMETRY_COLLECTION = MgeomgeojsontypeModule.GEOMETRY_COLLECTION;
M.geom.geojson.type.LINE_STRING = MgeomgeojsontypeModule.LINE_STRING;
M.geom.geojson.type.MULTI_LINE_STRING = MgeomgeojsontypeModule.MULTI_LINE_STRING;
M.geom.geojson.type.MULTI_POINT = MgeomgeojsontypeModule.MULTI_POINT;
M.geom.geojson.type.MULTI_POLYGON = MgeomgeojsontypeModule.MULTI_POLYGON;
M.geom.geojson.type.POINT = MgeomgeojsontypeModule.POINT;
M.geom.geojson.type.POLYGON = MgeomgeojsontypeModule.POLYGON;
M.geom.parse = MgeomModule.parse;
M.geom.parseWFS = MgeomModule.parseWFS;
M.geom.wfs = {};
M.geom.wfs.type = {};
M.geom.wfs.type.LINE = MgeomwfstypeModule.LINE;
M.geom.wfs.type.MLINE = MgeomwfstypeModule.MLINE;
M.geom.wfs.type.MPOINT = MgeomwfstypeModule.MPOINT;
M.geom.wfs.type.MPOLYGON = MgeomwfstypeModule.MPOLYGON;
M.geom.wfs.type.POINT = MgeomwfstypeModule.POINT;
M.geom.wfs.type.POLYGON = MgeomwfstypeModule.POLYGON;
M.geom.wkt = {};
M.geom.wkt.type = {};
M.geom.wkt.type.CIRCLE = MgeomwkttypeModule.CIRCLE;
M.geom.wkt.type.GEOMETRY = MgeomwkttypeModule.GEOMETRY;
M.geom.wkt.type.GEOMETRY_COLLECTION = MgeomwkttypeModule.GEOMETRY_COLLECTION;
M.geom.wkt.type.LINEAR_RING = MgeomwkttypeModule.LINEAR_RING;
M.geom.wkt.type.LINE_STRING = MgeomwkttypeModule.LINE_STRING;
M.geom.wkt.type.MULTI_LINE_STRING = MgeomwkttypeModule.MULTI_LINE_STRING;
M.geom.wkt.type.MULTI_POINT = MgeomwkttypeModule.MULTI_POINT;
M.geom.wkt.type.MULTI_POLYGON = MgeomwkttypeModule.MULTI_POLYGON;
M.geom.wkt.type.POINT = MgeomwkttypeModule.POINT;
M.geom.wkt.type.POLYGON = MgeomwkttypeModule.POLYGON;
M.handler = {};
M.handler.Feature = $M$handler$Feature;
M.impl = {};
M.impl.Control = $M$impl$Control;
M.impl.Feature = $M$impl$Feature;
M.impl.GetCapabilities = $M$impl$GetCapabilities;
M.impl.Label = $M$impl$Label;
M.impl.Layer = $M$impl$Layer;
M.impl.Map = $M$impl$Map;
M.impl.Popup = $M$impl$Popup;
M.impl.RenderFeature = $M$impl$RenderFeature;
M.impl.Style = $M$impl$Style;
M.impl.View = $M$impl$View;
M.impl.control = {};
M.impl.control.GetFeatureInfo = $M$impl$control$GetFeatureInfo;
M.impl.control.Location = $M$impl$control$Location;
M.impl.control.Panzoom = $M$impl$control$Panzoom;
M.impl.control.Panzoombar = $M$impl$control$Panzoombar;
M.impl.control.Rotate = $M$impl$control$Rotate;
M.impl.control.Scale = $M$impl$control$Scale;
M.impl.control.ScaleLine = $M$impl$control$ScaleLine;
M.impl.control.WMCSelector = $M$impl$control$WMCSelector;
M.impl.format = {};
M.impl.format.DescribeFeatureType = $M$impl$format$DescribeFeatureType;
M.impl.format.DescribeFeatureTypeXML = $M$impl$format$DescribeFeatureTypeXML;
M.impl.format.GML = $M$impl$format$GML;
M.impl.format.GeoJSON = $M$impl$format$GeoJSON;
M.impl.format.KML = $M$impl$format$KML;
M.impl.format.WKT = $M$impl$format$WKT;
M.impl.format.WMC = $M$impl$format$WMC;
M.impl.format.WMSCapabilities = $M$impl$format$WMSCapabilities;
M.impl.format.WMTSCapabilities = $M$impl$format$WMTSCapabilities;
M.impl.format.XML = $M$impl$format$XML;
M.impl.handler = {};
M.impl.handler.Feature = $M$impl$handler$Feature;
M.impl.interaction = {};
M.impl.interaction.SelectCluster = $M$impl$interaction$SelectCluster;
M.impl.layer = {};
M.impl.layer.AnimatedCluster = $M$impl$layer$AnimatedCluster;
M.impl.layer.Draw = $M$impl$layer$Draw;
M.impl.layer.GeoJSON = $M$impl$layer$GeoJSON;
M.impl.layer.KML = $M$impl$layer$KML;
M.impl.layer.LayerGroup = $M$impl$layer$LayerGroup;
M.impl.layer.MBTiles = $M$impl$layer$MBTiles;
M.impl.layer.MBTilesVector = $M$impl$layer$MBTilesVector;
M.impl.layer.MVT = $M$impl$layer$MVT;
M.impl.layer.OSM = $M$impl$layer$OSM;
M.impl.layer.TMS = $M$impl$layer$TMS;
M.impl.layer.Vector = $M$impl$layer$Vector;
M.impl.layer.WFS = $M$impl$layer$WFS;
M.impl.layer.WMC = $M$impl$layer$WMC;
M.impl.layer.WMS = $M$impl$layer$WMS;
M.impl.layer.WMTS = $M$impl$layer$WMTS;
M.impl.layer.XYZ = $M$impl$layer$XYZ;
M.impl.loader = {};
M.impl.loader.JSONP = $M$impl$loader$JSONP;
M.impl.loader.KML = $M$impl$loader$KML;
M.impl.loader.WFS = $M$impl$loader$WFS;
M.impl.service = {};
M.impl.service.WFS = $M$impl$service$WFS;
M.impl.source = {};
M.impl.source.ImageWMS = $M$impl$source$ImageWMS;
M.impl.source.TileWMS = $M$impl$source$TileWMS;
M.impl.style = {};
M.impl.style.Centroid = $M$impl$style$Centroid;
M.impl.style.Cluster = $M$impl$style$Cluster;
M.impl.style.Icon = $M$impl$style$Icon;
M.impl.style.Line = $M$impl$style$Line;
M.impl.style.Path = $M$impl$style$Path;
M.impl.style.Point = $M$impl$style$Point;
M.impl.style.Polygon = $M$impl$style$Polygon;
M.impl.style.Simple = $M$impl$style$Simple;
M.impl.util = {};
M.impl.util.wmtscapabilities = $M$impl$util$wmtscapabilities;
M.impl.util.wmtscapabilities.getLayers = MimplutilwmtscapabilitiesModule.getLayers;
M.impl.utils = $M$impl$utils;
M.language = {};
M.language.addTranslation = MlanguageModule.addTranslation;
M.language.getLang = MlanguageModule.getLang;
M.language.getTranslation = MlanguageModule.getTranslation;
M.language.getValue = MlanguageModule.getValue;
M.language.setLang = MlanguageModule.setLang;
M.layer = {};
M.layer.GeoJSON = $M$layer$GeoJSON;
M.layer.KML = $M$layer$KML;
M.layer.LayerGroup = $M$layer$LayerGroup;
M.layer.MBTiles = $M$layer$MBTiles;
M.layer.MBTilesVector = $M$layer$MBTilesVector;
M.layer.MBTilesVector.mode = MlayerMBTilesVectorModule.mode;
M.layer.MVT = $M$layer$MVT;
M.layer.MVT.mode = MlayerMVTModule.mode;
M.layer.OSM = $M$layer$OSM;
M.layer.TMS = $M$layer$TMS;
M.layer.Vector = $M$layer$Vector;
M.layer.WFS = $M$layer$WFS;
M.layer.WMC = $M$layer$WMC;
M.layer.WMS = $M$layer$WMS;
M.layer.WMTS = $M$layer$WMTS;
M.layer.XYZ = $M$layer$XYZ;
M.layer.type = {};
M.layer.type.GeoJSON = MlayertypeModule.GeoJSON;
M.layer.type.KML = MlayertypeModule.KML;
M.layer.type.MBTiles = MlayertypeModule.MBTiles;
M.layer.type.MBTilesVector = MlayertypeModule.MBTilesVector;
M.layer.type.MVT = MlayertypeModule.MVT;
M.layer.type.OSM = MlayertypeModule.OSM;
M.layer.type.TMS = MlayertypeModule.TMS;
M.layer.type.Vector = MlayertypeModule.Vector;
M.layer.type.WFS = MlayertypeModule.WFS;
M.layer.type.WMC = MlayertypeModule.WMC;
M.layer.type.WMS = MlayertypeModule.WMS;
M.layer.type.WMTS = MlayertypeModule.WMTS;
M.layer.type.XYZ = MlayertypeModule.XYZ;
M.map = MModule.map;
M.parameter = {};
M.parameter.center = MparameterModule.center;
M.parameter.geojson = MparameterModule.geojson;
M.parameter.kml = MparameterModule.kml;
M.parameter.layer = MparameterModule.layer;
M.parameter.maxExtent = MparameterModule.maxExtent;
M.parameter.maxZoom = MparameterModule.maxZoom;
M.parameter.mbtiles = $M$parameter$mbtiles;
M.parameter.mbtilesvector = $M$parameter$mbtilesvector;
M.parameter.minZoom = MparameterModule.minZoom;
M.parameter.mvt = MparameterModule.mvt;
M.parameter.osm = $M$parameter$osm;
M.parameter.projection = MparameterModule.projection;
M.parameter.resolutions = MparameterModule.resolutions;
M.parameter.tms = $M$parameter$tms;
M.parameter.tms = MparameterModule.tms;
M.parameter.wfs = MparameterModule.wfs;
M.parameter.wmc = $M$parameter$wmc;
M.parameter.wmc = MparameterModule.wmc;
M.parameter.wms = $M$parameter$wms;
M.parameter.wms = MparameterModule.wms;
M.parameter.wmts = MparameterModule.wmts;
M.parameter.xyz = $M$parameter$xyz;
M.parameter.xyz = MparameterModule.xyz;
M.parameter.zoom = MparameterModule.zoom;
M.proxy = MModule.proxy;
M.remote = {};
M.remote.Response = $M$remote$Response;
M.remote.get = MremoteModule.get;
M.remote.post = MremoteModule.post;
M.style = {};
M.style.Cluster = $M$style$Cluster;
M.style.Composite = $M$style$Composite;
M.style.Feature = $M$style$Feature;
M.style.Line = $M$style$Line;
M.style.Point = $M$style$Point;
M.style.Polygon = $M$style$Polygon;
M.style.Simple = $M$style$Simple;
M.style.align = {};
M.style.align.CENTER = MstylealignModule.CENTER;
M.style.align.JUSTIFY = MstylealignModule.JUSTIFY;
M.style.align.LEFT = MstylealignModule.LEFT;
M.style.align.RIGHT = MstylealignModule.RIGHT;
M.style.baseline = {};
M.style.baseline.ALPHABETIC = MstylebaselineModule.ALPHABETIC;
M.style.baseline.BOTTOM = MstylebaselineModule.BOTTOM;
M.style.baseline.HANGING = MstylebaselineModule.HANGING;
M.style.baseline.IDEOGRAPHIC = MstylebaselineModule.IDEOGRAPHIC;
M.style.baseline.MIDDLE = MstylebaselineModule.MIDDLE;
M.style.baseline.TOP = MstylebaselineModule.TOP;
M.style.form = {};
M.style.form.BAN = MstyleformModule.BAN;
M.style.form.BLAZON = MstyleformModule.BLAZON;
M.style.form.BUBBLE = MstyleformModule.BUBBLE;
M.style.form.CIRCLE = MstyleformModule.CIRCLE;
M.style.form.LOZENGE = MstyleformModule.LOZENGE;
M.style.form.MARKER = MstyleformModule.MARKER;
M.style.form.NONE = MstyleformModule.NONE;
M.style.form.SHIELD = MstyleformModule.SHIELD;
M.style.form.SIGN = MstyleformModule.SIGN;
M.style.form.SQUARE = MstyleformModule.SQUARE;
M.style.form.TRIANGLE = MstyleformModule.TRIANGLE;
M.style.pattern = {};
M.style.pattern.BRECCIA = MstylepatternModule.BRECCIA;
M.style.pattern.BRICK = MstylepatternModule.BRICK;
M.style.pattern.CAPS = MstylepatternModule.CAPS;
M.style.pattern.CEMETRY = MstylepatternModule.CEMETRY;
M.style.pattern.CHAOS = MstylepatternModule.CHAOS;
M.style.pattern.CHARACTER = MstylepatternModule.CHARACTER;
M.style.pattern.CIRCLE = MstylepatternModule.CIRCLE;
M.style.pattern.CLAY = MstylepatternModule.CLAY;
M.style.pattern.COAL = MstylepatternModule.COAL;
M.style.pattern.CONGLOMERATE = MstylepatternModule.CONGLOMERATE;
M.style.pattern.CROSS = MstylepatternModule.CROSS;
M.style.pattern.CROSSES = MstylepatternModule.CROSSES;
M.style.pattern.DOLOMITE = MstylepatternModule.DOLOMITE;
M.style.pattern.DOT = MstylepatternModule.DOT;
M.style.pattern.FLOODED = MstylepatternModule.FLOODED;
M.style.pattern.FOREST = MstylepatternModule.FOREST;
M.style.pattern.GRASS = MstylepatternModule.GRASS;
M.style.pattern.GRAVEL = MstylepatternModule.GRAVEL;
M.style.pattern.HATCH = MstylepatternModule.HATCH;
M.style.pattern.HEXAGON = MstylepatternModule.HEXAGON;
M.style.pattern.ICON = MstylepatternModule.ICON;
M.style.pattern.IMAGE = MstylepatternModule.IMAGE;
M.style.pattern.NYLON = MstylepatternModule.NYLON;
M.style.pattern.PINE = MstylepatternModule.PINE;
M.style.pattern.PINES = MstylepatternModule.PINES;
M.style.pattern.ROCK = MstylepatternModule.ROCK;
M.style.pattern.ROCKS = MstylepatternModule.ROCKS;
M.style.pattern.SAND = MstylepatternModule.SAND;
M.style.pattern.SCRUB = MstylepatternModule.SCRUB;
M.style.pattern.SQUARE = MstylepatternModule.SQUARE;
M.style.pattern.SWAMP = MstylepatternModule.SWAMP;
M.style.pattern.TILE = MstylepatternModule.TILE;
M.style.pattern.TREE = MstylepatternModule.TREE;
M.style.pattern.VINE = MstylepatternModule.VINE;
M.style.pattern.WAVE = MstylepatternModule.WAVE;
M.style.pattern.WOVEN = MstylepatternModule.WOVEN;
M.style.state = {};
M.style.state.DEFAULT = MstylestateModule.DEFAULT;
M.style.state.NEW = MstylestateModule.NEW;
M.style.state.SELECTED = MstylestateModule.SELECTED;
M.style.textoverflow = {};
M.style.textoverflow.ELLIPSIS = MstyletextoverflowModule.ELLIPSIS;
M.style.textoverflow.HIDDEN = MstyletextoverflowModule.HIDDEN;
M.style.textoverflow.VISIBLE = MstyletextoverflowModule.VISIBLE;
M.template = {};
M.template.add = MtemplateModule.add;
M.template.compile = MtemplateModule.compile;
M.template.compileSync = MtemplateModule.compileSync;
M.template.get = MtemplateModule.get;
M.ui = {};
M.ui.Panel = $M$ui$Panel;
M.ui.position = {};
M.ui.position.BL = MuipositionModule.BL;
M.ui.position.BR = MuipositionModule.BR;
M.ui.position.TL = MuipositionModule.TL;
M.ui.position.TR = MuipositionModule.TR;
M.units = {};
M.units.DOTS_PER_INCH = MunitsModule.DOTS_PER_INCH;
M.units.INCHES_PER_UNIT = MunitsModule.INCHES_PER_UNIT;
M.utils = {};
M.utils.addParameters = MutilsModule.addParameters;
M.utils.beautifyAttribute = MutilsModule.beautifyAttribute;
M.utils.beautifyAttributeName = MutilsModule.beautifyAttributeName;
M.utils.beautifyString = MutilsModule.beautifyString;
M.utils.concatUrlPaths = MutilsModule.concatUrlPaths;
M.utils.decodeHtml = MutilsModule.decodeHtml;
M.utils.defineFunctionFromString = MutilsModule.defineFunctionFromString;
M.utils.drawDynamicStyle = MutilsModule.drawDynamicStyle;
M.utils.enableTouchScroll = MutilsModule.enableTouchScroll;
M.utils.escapeJSCode = MutilsModule.escapeJSCode;
M.utils.escapeXSS = MutilsModule.escapeXSS;
M.utils.extend = MutilsModule.extend;
M.utils.extendsObj = MutilsModule.extendsObj;
M.utils.fillResolutions = MutilsModule.fillResolutions;
M.utils.generateRandom = MutilsModule.generateRandom;
M.utils.generateResolutionsFromExtent = MutilsModule.generateResolutionsFromExtent;
M.utils.generateResolutionsFromScales = MutilsModule.generateResolutionsFromScales;
M.utils.getEnvolvedExtent = MutilsModule.getEnvolvedExtent;
M.utils.getImageSize = MutilsModule.getImageSize;
M.utils.getOpacityFromRgba = MutilsModule.getOpacityFromRgba;
M.utils.getParameterValue = MutilsModule.getParameterValue;
M.utils.getResolutionFromScale = MutilsModule.getResolutionFromScale;
M.utils.getRgba = MutilsModule.getRgba;
M.utils.getScaleFromResolution = MutilsModule.getScaleFromResolution;
M.utils.getTextFromHtml = MutilsModule.getTextFromHtml;
M.utils.getWMSGetCapabilitiesUrl = MutilsModule.getWMSGetCapabilitiesUrl;
M.utils.getWMTSGetCapabilitiesUrl = MutilsModule.getWMTSGetCapabilitiesUrl;
M.utils.htmlToString = MutilsModule.htmlToString;
M.utils.includes = MutilsModule.includes;
M.utils.inverseColor = MutilsModule.inverseColor;
M.utils.isArray = MutilsModule.isArray;
M.utils.isBoolean = MutilsModule.isBoolean;
M.utils.isDynamic = MutilsModule.isDynamic;
M.utils.isFunction = MutilsModule.isFunction;
M.utils.isGeometryType = MutilsModule.isGeometryType;
M.utils.isNull = MutilsModule.isNull;
M.utils.isNullOrEmpty = MutilsModule.isNullOrEmpty;
M.utils.isObject = MutilsModule.isObject;
M.utils.isString = MutilsModule.isString;
M.utils.isUndefined = MutilsModule.isUndefined;
M.utils.isUrl = MutilsModule.isUrl;
M.utils.normalize = MutilsModule.normalize;
M.utils.rgbToHex = MutilsModule.rgbToHex;
M.utils.rgbaToHex = MutilsModule.rgbaToHex;
M.utils.sameUrl = MutilsModule.sameUrl;
M.utils.setDynamicLegend = MutilsModule.setDynamicLegend;
M.utils.stringToHtml = MutilsModule.stringToHtml;
M.utils.stringifyFunctions = MutilsModule.stringifyFunctions;
M.utils.styleComparator = MutilsModule.styleComparator;
M.window = $M$window;
ol.AssertionError = $ol$AssertionError;
ol.Collection = $ol$Collection;
ol.Feature = $ol$Feature;
ol.Geolocation = $ol$Geolocation;
ol.Kinetic = $ol$Kinetic;
ol.Map = $ol$Map;
ol.MapBrowserEvent = $ol$MapBrowserEvent;
ol.Object = $ol$Object;
ol.Observable = $ol$Observable;
ol.Observable.unByKey = olObservableModule.unByKey;
ol.Overlay = $ol$Overlay;
ol.PluggableMap = $ol$PluggableMap;
ol.View = $ol$View;
ol.array = {};
ol.array.stableSort = olarrayModule.stableSort;
ol.color = {};
ol.color.asArray = olcolorModule.asArray;
ol.color.asString = olcolorModule.asString;
ol.colorlike = {};
ol.colorlike.asColorLike = olcolorlikeModule.asColorLike;
ol.control = {};
ol.control.Attribution = $ol$control$Attribution;
ol.control.Control = $ol$control$Control;
ol.control.FullScreen = $ol$control$FullScreen;
ol.control.MousePosition = $ol$control$MousePosition;
ol.control.OverviewMap = $ol$control$OverviewMap;
ol.control.Rotate = $ol$control$Rotate;
ol.control.ScaleLine = $ol$control$ScaleLine;
ol.control.Zoom = $ol$control$Zoom;
ol.control.ZoomSlider = $ol$control$ZoomSlider;
ol.control.ZoomToExtent = $ol$control$ZoomToExtent;
ol.control.defaults = olcontrolModule.defaults;
ol.coordinate = {};
ol.coordinate.add = olcoordinateModule.add;
ol.coordinate.createStringXY = olcoordinateModule.createStringXY;
ol.coordinate.format = olcoordinateModule.format;
ol.coordinate.rotate = olcoordinateModule.rotate;
ol.coordinate.toStringHDMS = olcoordinateModule.toStringHDMS;
ol.coordinate.toStringXY = olcoordinateModule.toStringXY;
ol.easing = {};
ol.easing.easeIn = oleasingModule.easeIn;
ol.easing.easeOut = oleasingModule.easeOut;
ol.easing.inAndOut = oleasingModule.inAndOut;
ol.easing.linear = oleasingModule.linear;
ol.easing.upAndDown = oleasingModule.upAndDown;
ol.events = {};
ol.events.condition = {};
ol.events.condition.altKeyOnly = oleventsconditionModule.altKeyOnly;
ol.events.condition.altShiftKeysOnly = oleventsconditionModule.altShiftKeysOnly;
ol.events.condition.always = oleventsconditionModule.always;
ol.events.condition.click = oleventsconditionModule.click;
ol.events.condition.doubleClick = oleventsconditionModule.doubleClick;
ol.events.condition.focus = oleventsconditionModule.focus;
ol.events.condition.mouseOnly = oleventsconditionModule.mouseOnly;
ol.events.condition.never = oleventsconditionModule.never;
ol.events.condition.noModifierKeys = oleventsconditionModule.noModifierKeys;
ol.events.condition.penOnly = oleventsconditionModule.penOnly;
ol.events.condition.platformModifierKeyOnly = oleventsconditionModule.platformModifierKeyOnly;
ol.events.condition.pointerMove = oleventsconditionModule.pointerMove;
ol.events.condition.primaryAction = oleventsconditionModule.primaryAction;
ol.events.condition.shiftKeyOnly = oleventsconditionModule.shiftKeyOnly;
ol.events.condition.singleClick = oleventsconditionModule.singleClick;
ol.events.condition.targetNotEditable = oleventsconditionModule.targetNotEditable;
ol.events.condition.touchOnly = oleventsconditionModule.touchOnly;
ol.extent = {};
ol.extent.applyTransform = olextentModule.applyTransform;
ol.extent.boundingExtent = olextentModule.boundingExtent;
ol.extent.buffer = olextentModule.buffer;
ol.extent.containsCoordinate = olextentModule.containsCoordinate;
ol.extent.containsExtent = olextentModule.containsExtent;
ol.extent.containsXY = olextentModule.containsXY;
ol.extent.createEmpty = olextentModule.createEmpty;
ol.extent.equals = olextentModule.equals;
ol.extent.extend = olextentModule.extend;
ol.extent.getArea = olextentModule.getArea;
ol.extent.getBottomLeft = olextentModule.getBottomLeft;
ol.extent.getBottomRight = olextentModule.getBottomRight;
ol.extent.getCenter = olextentModule.getCenter;
ol.extent.getHeight = olextentModule.getHeight;
ol.extent.getIntersection = olextentModule.getIntersection;
ol.extent.getSize = olextentModule.getSize;
ol.extent.getTopLeft = olextentModule.getTopLeft;
ol.extent.getTopRight = olextentModule.getTopRight;
ol.extent.getWidth = olextentModule.getWidth;
ol.extent.intersects = olextentModule.intersects;
ol.extent.isEmpty = olextentModule.isEmpty;
ol.featureloader = {};
ol.featureloader.setWithCredentials = olfeatureloaderModule.setWithCredentials;
ol.featureloader.xhr = olfeatureloaderModule.xhr;
ol.format = {};
ol.format.EsriJSON = $ol$format$EsriJSON;
ol.format.Feature = $ol$format$Feature;
ol.format.GML = $ol$format$GML;
ol.format.GML2 = $ol$format$GML2;
ol.format.GML3 = $ol$format$GML3;
ol.format.GML32 = $ol$format$GML32;
ol.format.GPX = $ol$format$GPX;
ol.format.GeoJSON = $ol$format$GeoJSON;
ol.format.IGC = $ol$format$IGC;
ol.format.IIIFInfo = $ol$format$IIIFInfo;
ol.format.KML = $ol$format$KML;
ol.format.MVT = $ol$format$MVT;
ol.format.OSMXML = $ol$format$OSMXML;
ol.format.Polyline = $ol$format$Polyline;
ol.format.Polyline.decodeDeltas = olformatPolylineModule.decodeDeltas;
ol.format.Polyline.decodeFloats = olformatPolylineModule.decodeFloats;
ol.format.Polyline.encodeDeltas = olformatPolylineModule.encodeDeltas;
ol.format.Polyline.encodeFloats = olformatPolylineModule.encodeFloats;
ol.format.TopoJSON = $ol$format$TopoJSON;
ol.format.WFS = $ol$format$WFS;
ol.format.WFS.writeFilter = olformatWFSModule.writeFilter;
ol.format.WKT = $ol$format$WKT;
ol.format.WMSCapabilities = $ol$format$WMSCapabilities;
ol.format.WMSGetFeatureInfo = $ol$format$WMSGetFeatureInfo;
ol.format.WMTSCapabilities = $ol$format$WMTSCapabilities;
ol.format.filter = {};
ol.format.filter.Bbox = $ol$format$filter$Bbox;
ol.format.filter.Contains = $ol$format$filter$Contains;
ol.format.filter.During = $ol$format$filter$During;
ol.format.filter.EqualTo = $ol$format$filter$EqualTo;
ol.format.filter.GreaterThan = $ol$format$filter$GreaterThan;
ol.format.filter.GreaterThanOrEqualTo = $ol$format$filter$GreaterThanOrEqualTo;
ol.format.filter.Intersects = $ol$format$filter$Intersects;
ol.format.filter.IsBetween = $ol$format$filter$IsBetween;
ol.format.filter.IsLike = $ol$format$filter$IsLike;
ol.format.filter.IsNull = $ol$format$filter$IsNull;
ol.format.filter.LessThan = $ol$format$filter$LessThan;
ol.format.filter.LessThanOrEqualTo = $ol$format$filter$LessThanOrEqualTo;
ol.format.filter.Not = $ol$format$filter$Not;
ol.format.filter.NotEqualTo = $ol$format$filter$NotEqualTo;
ol.format.filter.Or = $ol$format$filter$Or;
ol.format.filter.Within = $ol$format$filter$Within;
ol.format.filter.and = olformatfilterModule.and;
ol.format.filter.bbox = olformatfilterModule.bbox;
ol.format.filter.between = olformatfilterModule.between;
ol.format.filter.contains = olformatfilterModule.contains;
ol.format.filter.during = olformatfilterModule.during;
ol.format.filter.equalTo = olformatfilterModule.equalTo;
ol.format.filter.greaterThan = olformatfilterModule.greaterThan;
ol.format.filter.greaterThanOrEqualTo = olformatfilterModule.greaterThanOrEqualTo;
ol.format.filter.intersects = olformatfilterModule.intersects;
ol.format.filter.isNull = olformatfilterModule.isNull;
ol.format.filter.lessThan = olformatfilterModule.lessThan;
ol.format.filter.lessThanOrEqualTo = olformatfilterModule.lessThanOrEqualTo;
ol.format.filter.like = olformatfilterModule.like;
ol.format.filter.not = olformatfilterModule.not;
ol.format.filter.notEqualTo = olformatfilterModule.notEqualTo;
ol.format.filter.or = olformatfilterModule.or;
ol.format.filter.within = olformatfilterModule.within;
ol.geom = {};
ol.geom.Circle = $ol$geom$Circle;
ol.geom.Geometry = $ol$geom$Geometry;
ol.geom.GeometryCollection = $ol$geom$GeometryCollection;
ol.geom.LineString = $ol$geom$LineString;
ol.geom.LinearRing = $ol$geom$LinearRing;
ol.geom.MultiLineString = $ol$geom$MultiLineString;
ol.geom.MultiPoint = $ol$geom$MultiPoint;
ol.geom.MultiPolygon = $ol$geom$MultiPolygon;
ol.geom.Point = $ol$geom$Point;
ol.geom.Polygon = $ol$geom$Polygon;
ol.geom.Polygon.circular = olgeomPolygonModule.circular;
ol.geom.Polygon.fromCircle = olgeomPolygonModule.fromCircle;
ol.geom.Polygon.fromExtent = olgeomPolygonModule.fromExtent;
ol.geom.SimpleGeometry = $ol$geom$SimpleGeometry;
ol.has = {};
ol.has.DEVICE_PIXEL_RATIO = olhasModule.DEVICE_PIXEL_RATIO;
ol.interaction = {};
ol.interaction.DoubleClickZoom = $ol$interaction$DoubleClickZoom;
ol.interaction.DragAndDrop = $ol$interaction$DragAndDrop;
ol.interaction.DragBox = $ol$interaction$DragBox;
ol.interaction.DragPan = $ol$interaction$DragPan;
ol.interaction.DragRotate = $ol$interaction$DragRotate;
ol.interaction.DragRotateAndZoom = $ol$interaction$DragRotateAndZoom;
ol.interaction.DragZoom = $ol$interaction$DragZoom;
ol.interaction.Draw = $ol$interaction$Draw;
ol.interaction.Draw.createBox = olinteractionDrawModule.createBox;
ol.interaction.Draw.createRegularPolygon = olinteractionDrawModule.createRegularPolygon;
ol.interaction.Extent = $ol$interaction$Extent;
ol.interaction.Interaction = $ol$interaction$Interaction;
ol.interaction.KeyboardPan = $ol$interaction$KeyboardPan;
ol.interaction.KeyboardZoom = $ol$interaction$KeyboardZoom;
ol.interaction.Modify = $ol$interaction$Modify;
ol.interaction.MouseWheelZoom = $ol$interaction$MouseWheelZoom;
ol.interaction.PinchRotate = $ol$interaction$PinchRotate;
ol.interaction.PinchZoom = $ol$interaction$PinchZoom;
ol.interaction.Pointer = $ol$interaction$Pointer;
ol.interaction.Select = $ol$interaction$Select;
ol.interaction.Snap = $ol$interaction$Snap;
ol.interaction.Translate = $ol$interaction$Translate;
ol.interaction.defaults = olinteractionModule.defaults;
ol.layer = {};
ol.layer.Base = $ol$layer$Base;
ol.layer.BaseImage = $ol$layer$BaseImage;
ol.layer.BaseTile = $ol$layer$BaseTile;
ol.layer.BaseVector = $ol$layer$BaseVector;
ol.layer.Graticule = $ol$layer$Graticule;
ol.layer.Group = $ol$layer$Group;
ol.layer.Heatmap = $ol$layer$Heatmap;
ol.layer.Image = $ol$layer$Image;
ol.layer.Layer = $ol$layer$Layer;
ol.layer.Tile = $ol$layer$Tile;
ol.layer.Vector = $ol$layer$Vector;
ol.layer.VectorImage = $ol$layer$VectorImage;
ol.layer.VectorTile = $ol$layer$VectorTile;
ol.loadingstrategy = {};
ol.loadingstrategy.all = olloadingstrategyModule.all;
ol.loadingstrategy.bbox = olloadingstrategyModule.bbox;
ol.loadingstrategy.tile = olloadingstrategyModule.tile;
ol.proj = {};
ol.proj.Projection = $ol$proj$Projection;
ol.proj.Units = {};
ol.proj.Units.METERS_PER_UNIT = olprojUnitsModule.METERS_PER_UNIT;
ol.proj.addCoordinateTransforms = olprojModule.addCoordinateTransforms;
ol.proj.addEquivalentProjections = olprojModule.addEquivalentProjections;
ol.proj.addProjection = olprojModule.addProjection;
ol.proj.equivalent = olprojModule.equivalent;
ol.proj.fromLonLat = olprojModule.fromLonLat;
ol.proj.get = olprojModule.get;
ol.proj.getPointResolution = olprojModule.getPointResolution;
ol.proj.getTransform = olprojModule.getTransform;
ol.proj.proj4 = {};
ol.proj.proj4.register = olprojproj4Module.register;
ol.proj.toLonLat = olprojModule.toLonLat;
ol.proj.transform = olprojModule.transform;
ol.proj.transformExtent = olprojModule.transformExtent;
ol.render = {};
ol.render.VectorContext = $ol$render$VectorContext;
ol.render.canvas = {};
ol.render.canvas.labelCache = olrendercanvasModule.labelCache;
ol.render.getRenderPixel = olrenderModule.getRenderPixel;
ol.render.getVectorContext = olrenderModule.getVectorContext;
ol.render.toContext = olrenderModule.toContext;
ol.renderer = {};
ol.renderer.Composite = $ol$renderer$Composite;
ol.renderer.canvas = {};
ol.renderer.canvas.ImageLayer = $ol$renderer$canvas$ImageLayer;
ol.renderer.canvas.TileLayer = $ol$renderer$canvas$TileLayer;
ol.renderer.canvas.VectorImageLayer = $ol$renderer$canvas$VectorImageLayer;
ol.renderer.canvas.VectorLayer = $ol$renderer$canvas$VectorLayer;
ol.renderer.canvas.VectorTileLayer = $ol$renderer$canvas$VectorTileLayer;
ol.renderer.webgl = {};
ol.renderer.webgl.PointsLayer = $ol$renderer$webgl$PointsLayer;
ol.size = {};
ol.size.toSize = olsizeModule.toSize;
ol.source = {};
ol.source.BingMaps = $ol$source$BingMaps;
ol.source.CartoDB = $ol$source$CartoDB;
ol.source.Cluster = $ol$source$Cluster;
ol.source.IIIF = $ol$source$IIIF;
ol.source.Image = $ol$source$Image;
ol.source.ImageArcGISRest = $ol$source$ImageArcGISRest;
ol.source.ImageCanvas = $ol$source$ImageCanvas;
ol.source.ImageMapGuide = $ol$source$ImageMapGuide;
ol.source.ImageStatic = $ol$source$ImageStatic;
ol.source.ImageWMS = $ol$source$ImageWMS;
ol.source.OSM = $ol$source$OSM;
ol.source.OSM.ATTRIBUTION = olsourceOSMModule.ATTRIBUTION;
ol.source.Raster = $ol$source$Raster;
ol.source.Source = $ol$source$Source;
ol.source.Stamen = $ol$source$Stamen;
ol.source.Tile = $ol$source$Tile;
ol.source.TileArcGISRest = $ol$source$TileArcGISRest;
ol.source.TileDebug = $ol$source$TileDebug;
ol.source.TileImage = $ol$source$TileImage;
ol.source.TileJSON = $ol$source$TileJSON;
ol.source.TileWMS = $ol$source$TileWMS;
ol.source.UTFGrid = $ol$source$UTFGrid;
ol.source.Vector = $ol$source$Vector;
ol.source.VectorTile = $ol$source$VectorTile;
ol.source.WMSServerType = {};
ol.source.WMSServerType.CARMENTA_SERVER = olsourceWMSServerTypeModule.CARMENTA_SERVER;
ol.source.WMSServerType.GEOSERVER = olsourceWMSServerTypeModule.GEOSERVER;
ol.source.WMSServerType.MAPSERVER = olsourceWMSServerTypeModule.MAPSERVER;
ol.source.WMSServerType.QGIS = olsourceWMSServerTypeModule.QGIS;
ol.source.WMTS = $ol$source$WMTS;
ol.source.WMTS.optionsFromCapabilities = olsourceWMTSModule.optionsFromCapabilities;
ol.source.XYZ = $ol$source$XYZ;
ol.source.Zoomify = $ol$source$Zoomify;
ol.sphere = {};
ol.sphere.getArea = olsphereModule.getArea;
ol.sphere.getDistance = olsphereModule.getDistance;
ol.sphere.getLength = olsphereModule.getLength;
ol.style = {};
ol.style.Circle = $ol$style$Circle;
ol.style.Fill = $ol$style$Fill;
ol.style.Icon = $ol$style$Icon;
ol.style.IconAnchorUnits = {};
ol.style.IconAnchorUnits.FRACTION = olstyleIconAnchorUnitsModule.FRACTION;
ol.style.IconAnchorUnits.PIXELS = olstyleIconAnchorUnitsModule.PIXELS;
ol.style.IconImageCache = {};
ol.style.IconImageCache.shared = olstyleIconImageCacheModule.shared;
ol.style.IconOrigin = {};
ol.style.IconOrigin.BOTTOM_LEFT = olstyleIconOriginModule.BOTTOM_LEFT;
ol.style.IconOrigin.BOTTOM_RIGHT = olstyleIconOriginModule.BOTTOM_RIGHT;
ol.style.IconOrigin.TOP_LEFT = olstyleIconOriginModule.TOP_LEFT;
ol.style.IconOrigin.TOP_RIGHT = olstyleIconOriginModule.TOP_RIGHT;
ol.style.Image = $ol$style$Image;
ol.style.RegularShape = $ol$style$RegularShape;
ol.style.Stroke = $ol$style$Stroke;
ol.style.Style = $ol$style$Style;
ol.style.Text = $ol$style$Text;
ol.tilegrid = {};
ol.tilegrid.TileGrid = $ol$tilegrid$TileGrid;
ol.tilegrid.WMTS = $ol$tilegrid$WMTS;
ol.tilegrid.WMTS.createFromCapabilitiesMatrixSet = oltilegridWMTSModule.createFromCapabilitiesMatrixSet;
ol.tilegrid.createXYZ = oltilegridModule.createXYZ;
ol.transform = {};
ol.transform.composeCssTransform = oltransformModule.composeCssTransform;
ol.util = {};
ol.util.getUid = olutilModule.getUid;
ol.webgl = {};
ol.webgl.ARRAY_BUFFER = olwebglModule.ARRAY_BUFFER;
ol.webgl.Buffer = $ol$webgl$Buffer;
ol.webgl.DYNAMIC_DRAW = olwebglModule.DYNAMIC_DRAW;
ol.webgl.ELEMENT_ARRAY_BUFFER = olwebglModule.ELEMENT_ARRAY_BUFFER;
ol.webgl.Helper = $ol$webgl$Helper;
ol.webgl.Helper.computeAttributesStride = olwebglHelperModule.computeAttributesStride;
ol.webgl.PostProcessingPass = $ol$webgl$PostProcessingPass;
ol.webgl.RenderTarget = $ol$webgl$RenderTarget;
ol.webgl.STATIC_DRAW = olwebglModule.STATIC_DRAW;
ol.webgl.STREAM_DRAW = olwebglModule.STREAM_DRAW;
ol.xml = {};
ol.xml.getAllTextContent = olxmlModule.getAllTextContent;
ol.xml.parse = olxmlModule.parse;
ol.xml.registerDocument = olxmlModule.registerDocument;
ol.xml.registerXMLSerializer = olxmlModule.registerXMLSerializer;
window['Handlebars'] = require('handlebars');
M.plugin = {}